module.exports = __webpack_public_path__ + "img/report_problem.bbc3773b.svg";